import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getSICDReportAvailableColumns } from './api';

export const path = '/reports/sicd';
export const getPath = (taskId: number) => `/ppr/task/${taskId}`;

const PageSICDReport: React.FC = (props) => {
  const SICDReport = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getSICDReportAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <SICDReport {...props} />;
};

export default PageSICDReport;
